// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { salesRepStyles } from "@gcg/App/Components/SalesRep/SalesRep.style";
import { InfoDisplayStyles, infoDisplayStylesTwo } from "@gcg/App/SharedStyles/InfoDisplayStyles";
import Chat from "@gcg/XDL/Icons/Chat";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Clickable from "@insite/mobius/Clickable/Clickable";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import React from "react";

export interface RepInfoProps {
    salesPersonData: string;
    clickable?: boolean;
    chat?: boolean;
    title?: string;
    billTo?: any;
}

const styles: InfoDisplayStyles = infoDisplayStylesTwo;

export const RepInfo: React.FC<RepInfoProps> = ({ salesPersonData, clickable, chat, title, billTo }) => {
    if (!salesPersonData) {
        return null;
    }

    const salesPerson = JSON.parse(salesPersonData);

    const handleChatLinkClick = () => {
        const salesRepId = salesPerson.SalespersonNumber;
        const customerId = billTo?.properties?.erpNumber;
        const salesOrg = billTo?.properties?.salesOrg;

        (window as any).openChat(salesRepId, customerId, salesOrg);
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsRepInfo">
                {title || translate("Rep Info")}
            </Typography>
            {salesPerson.Name && (
                <Typography {...styles.contentText} ellipsis={true} as="p">
                    {salesPerson.Name}
                </Typography>
            )}
            {salesPerson.Email && (
                <Typography {...styles.contentText} as="p">
                    {clickable && (
                        <Link href={`mailto:${salesPerson.Email}`} target="_blank">
                            {salesPerson.Email}
                        </Link>
                    )}
                    {!clickable && salesPerson.Email}
                </Typography>
            )}
            {salesPerson.Phone && (
                <Typography {...styles.contentText} as="p">
                    {clickable && (
                        <Link href={`tel:${salesPerson.Phone}`} target="_blank">
                            {salesPerson.Phone}
                        </Link>
                    )}
                    {!clickable && salesPerson.Phone}
                </Typography>
            )}
            {chat && (
                <Clickable {...salesRepStyles.SRChat} onClick={handleChatLinkClick}>
                    {translate("Chat with")} {salesPerson.Name}{" "}
                    <Icon {...salesRepStyles.icon} src={Chat} size={16} color="primary" />
                </Clickable>
            )}
        </StyledWrapper>
    );
};
